<template>
  <div id="app"  :class="currentLangClass">
    <Home />
  </div>
</template>

<script>
import Home from '@/views/HomePage.vue';

export default {
  components: {
    Home
  },

  computed: {
    currentLangClass() {
      return this.$i18n.locale === 'en'? 'lang-en' : 'lang-cn';
    }
  }
};
</script>

<style lang="less">
/* 全局样式，可根据需要添加或调整 */
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;
* {
  box-sizing: border-box;
}
html {
  font: 16px/1.5;
  -webkit-font-smoothing: antialiased;
  font-family: @mainFont;
}
img {
  display: block;
  margin: 0;
  width: 100%;
}
.lang-en {
  /* 英文下的各种样式规则，比如字体、字号、颜色等 */
  font-family: @mainFont;
  margin: 0;
  padding: 0;
}
.en {
  font-family: @mainFont;
}

.lang-cn {
  /* 中文下的各种样式规则 */
  font-family: 'AlibabaHealthFont',serif;
  margin: 0;
  padding: 0;
}
.cn {
  font-family: @mainFontCn;
}
/* 选择样式 */
.ant-select-open .ant-select-selection {
  border-color: rgba(@mainColor2, 0.5)!important;
}
.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active {
  border-color: rgba(@mainColor2, 0.5)!important;
}
.ant-select-selection:hover {
  border-color: rgba(@mainColor2, 0.5)!important;
}
.sMenu {
  .ant-drawer-content-wrapper {
    .ant-drawer-content {
      .ant-drawer-wrapper-body {
        .ant-drawer-body {
          padding: 0;
          .ant-menu {
            .ant-menu-item-selected {
              text-align: center;
              padding: 0;
              color: @mainColor1;
              border:none;
              background: rgba(@mainColor1, 0.1);
              transition: ease 0.8s;
              border-radius: 42px;
              margin: 0 auto;
            }
          }
          .ant-menu-vertical .ant-menu-item::after, .ant-menu-vertical-left .ant-menu-item::after, .ant-menu-vertical-right .ant-menu-item::after, .ant-menu-inline .ant-menu-item::after {
            border-right: none!important;
          }
          .ant-menu-item {
            text-align: center!important;
            padding: 0!important;
            transition: ease 0.8s;
          }
          .ant-menu-item:hover,.ant-menu-item-active, .ant-menu:not(.ant-menu-inline).ant-menu-submenu-open,.ant-menu-submenu-active.ant-menu-submenu-title:hover {
            color: @mainColor1;
          }
        }
      }
    }
  }
}
.all-c-main {
  height: calc(100vh - 110px);
  box-sizing: border-box;
}
.all-c {
  height: auto!important;
  padding: 7vh 0;
  box-sizing: border-box;
}
@media screen and (max-width: 768px) {
  body {
    font-size: 14px;
  }
  .all-c {
    height: auto!important;
    padding: 7vw 0;
    &-main {
      height: auto !important;
    }
  }
}
@media screen and (min-width: 1500px) {
  .all-c {
    height: auto!important;
    padding: 3vw 0;
    &-main {
      height: auto !important;
    }
  }
}

</style>
